<template>
  <div class="show-search">
    <div id="mobileHead">
      <el-header height="48px">
        <div class="head-wrap width-mobile">
          <div style="position: relative;">
            <!-- <img @click="toIndex" src="@/assets/images/logo.jpg" style="height: 50px;filter: drop-shadow(0 1px 1px rgba(0,0,0,0.5));"/> -->
            <div class="p-n02v3__shape">
              <a href="javascript:;" class="p-n02v3__shapelink ">
                <div class="p-n02v3__brand">
                  <div class="p-n02v3__shapegradient" title="会员商城" @click="toIndex">
                    <div class="p-body-copy-03">会员商城</div>
                  </div>
                  <div class="p-n02v3__philips" @click="toPhilips">
                    <img src="../assets/images/logo-text.svg" srcset="../assets/images/logo-text.svg 1x" width="85" alt="Philips">
                  </div>
                  <div class="p-n02v3__shapetop" aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMidYMid meet" x="0" y="0" width="98" height="45" viewBox="0, 0, 196, 90">
                      <path d="M154.001,90.001 C176.012,90.022 195.966,82.011 196.001,60 L196.001,0.001 L-0.001,0.001 L-0.001,90.001 L154.001,90.001 z" fill="#fff" id="Shape_top"></path>
                    </svg>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div style="position: relative;display: flex;align-items: center;">
            <van-icon name="wap-home-o" size="22" @click="toIndex" />
            <template v-if="isYiban">&nbsp;</template>
            <i class="iconfont icon-search1" v-if="!isYiban" style="margin: 0 10px;" @click="showSearch = !showSearch"></i>
            <span class="user-icon" @click="toCenter">
              <i v-if="isLogin" class="iconfont icon-gerenzhongxinyonghu01"></i>
              <i v-else class="iconfont icon-gerenzhongxin"></i>
            </span>
            <span class="user-cart" @click="toCart">
              <i class="iconfont icon-cart4e"></i>
              <em class="shopping-amount" v-if="isLogin && $store.getters.cartNum">{{$store.getters.cartNum}}</em>
            </span>
            <template v-if="!isYiban">
              <i class="iconfont icon-caidan" style="font-size: 22px;width: 24px;" @click="isShowCategory(1)" v-if="!menuShow"></i>
              <i class="el-icon-close" style="font-size: 24px;" @click="isShowCategory(2)" v-else></i>
            </template>
          </div>
        </div>
      </el-header>
      <div class="mobile-one-category" v-show="menuShow" :style="{height: categoryHeight}">
        <ul>
          <li v-for="(two,index) in oneCategory" :key="index" @click="getTwoCategory(two.id, two.name)">
            <span>{{two.name}}</span>
          </li>
        </ul>
      </div>
      <div class="search-wrap width-mobile" v-if="showSearch">
        <div style="position: relative; padding: 5px 0;">
          <div style="position: absolute;left: 5px;top: 50%;transform: translateY(-50%);">
            <i class="iconfont icon-search1" @click="handleIconClick"></i>
          </div>
          <form action="javascript:return true;" style="width: 90%; margin: 0 auto;">
            <input class="query-search" autofocus placeholder="您在寻找什么?" type="search" v-model="keyword" @keyup.enter="handleIconClick"/>
          </form>
          <div style="position: absolute;right: 5px;top: 50%;transform: translateY(-50%);">
            <i class="el-icon-close" @click="showSearch = false"></i>
          </div>
          <div class="auto-tip" v-show="keyword && restaurants.length != 0">
            <div v-for="(item,index) in restaurants" class="name" @click="handleSelect(item)" :key="index">
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <div class="mobile-category" v-if="isShowTwoCategory">
        <div class="category-content" :style="{left: positionLeft}">
          <h3>
            <span class="el-icon-arrow-left" @click="hideTwoCategory"></span>
            <span>{{oneCategoryName}}</span>
          </h3>
          <ul>
            <li v-for="(two,index) in twoCategory" :key="index" @click="toProList(two)">
              <span>{{two.name}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/assets/js/request'
import { mapActions } from 'vuex'
// import totalVm from '@/assets/js/event'
export default {
  name: 'Head',
  data () {
    return {
      menuShow: false,
      showSearch: false,
      positionLeft: '100%',
      categoryHeight: '0',
      activeName: '1',
      oneCategory: [],
      twoCategory: [],
      oneCategoryId: '',
      oneCategoryName: '',
      isShowTwoCategory: false, // 是否显示二级菜单
      isLogin: false,
      keyword: '',
      isYiban: false,
      restaurants: []
    }
  },
  watch: {
    showSearch (val) {
      if (val == false) {
        this.keyword = ''
      }
    },
    keyword (val) {
      if (!val) {
        this.restaurants = []
      } else {
        this.querySearch()
      }
    },
    // 由于$store.getters.status给this.isLogin赋值不是即时性的，所以需要监听赋值
    '$store.getters.status': {
      immediate: true,
      handler (val) {
        if (val) {
          this.isLogin = true
        }
      }
    }
  },
  created () {
    this.isLogin = this.$store.getters.status
    this.initOne()
    if (this.isLogin) {
      this.loadCartNum()
    }
    try {
      if (localStorage.getItem('isForm') == 1) {
        this.isYiban = true
      }
    } catch (error) {}
  },
  methods: {
    ...mapActions([
      'loadCartNum'
    ]),
    toCart () {
      this.isShowCategory(2)
      if (this.isLogin) {
        if (this.$route.name != 'cart') {
          this.$router.push('/cart')
        }
      } else {
        let href = '/cart'
        this.$router.replace(`/login?redirectUrl=${href}`)
      }
    },
    toIndex () {
      if (this.isYiban) {
        this.$router.push('/activityShop')
        return
      }
      this.isShowCategory(2)
      if (this.$route.name != 'index') {
        this.$router.push('/index')
      }
      // this.$router.push('/index')
    },
    toPhilips () {
      debugger
      if (this.isYiban) return
      window.open('https://www.philips.com.cn/', '_blank')
    },
    toCenter () {
      debugger
      this.isShowCategory(2)
      if (this.isLogin) {
        if (this.$route.name != 'center') {
          this.$router.push('/center')
        }
      } else {
        let href = '/center'
        this.$router.replace(`/login?redirectUrl=${href}`)
      }
      // this.$router.push('/center')
    },
    isShowCategory (type) {
      if (type == 1) {
        this.menuShow = true
        this.categoryHeight = 'auto'
      } else {
        this.categoryHeight = '0'
        this.menuShow = false
        this.hideTwoCategory()
      }
    },
    async initOne () {
      try {
        let res = await request('/gateway/product/product/product-category/list/tab/0', 'get')
        this.oneCategory = res.data || []
      } catch (e) {
      }
    },
    async querySearch () {
      if (this.keyword) {
        let res = await request('/gateway/product/product/product/searchTips', 'post', {
          name: this.keyword,
          pageSize: 1000,
          pageNum: 1
        })
        let result = res.data.list ? res.data.list : []
        this.restaurants = result
      }
    },
    handleSelect (val) {
      this.keyword = val
      this.restaurants = []
      this.handleIconClick()
    },
    handleIconClick () {
      this.showSearch = false
      this.$router.push(`/product-list?keyword=${this.keyword}`)
    },
    async getTwoCategory (id, name) {
      this.oneCategoryId = id
      this.oneCategoryName = name
      try {
        let res = await request(`/gateway/product/product/product-category/list/tab/${id}`, 'get')
        this.twoCategory = res.data || []
        if (this.twoCategory.length) {
          this.isShowTwoCategory = true
          let t = setTimeout(() => {
            this.positionLeft = '0'
            clearTimeout(t)
          }, 100)
        } else {
          // 没有二级分类，直接跳转列表
          sessionStorage.setItem('banner', '') // 没有二级分类，列表就没有banner图
          this.$router.push(`/product-list?oneId=${id}`)
          this.isShowCategory(2)
        }
      } catch (e) {
      }
    },
    hideTwoCategory () {
      this.positionLeft = '100%'
      let t = setTimeout(() => {
        this.isShowTwoCategory = false
        clearTimeout(t)
      }, 500)
      this.oneCategoryId = ''
      this.oneCategoryName = ''
    },
    toProList (item) {
      // sessionStorage.setItem('banner', item.navIcon) // 供移动端用，列表页面刷新之后，vuex中就没数据了（因为页面刷新就不是从头部点击分类进去的，所以没有触发分类事件）
      // this.$store.commit('SET_BANNER', item.navIcon)
      // this.$router.push(`/product-list?oneId=${this.oneCategoryId}&twoId=${item.id}`)
      // this.isShowCategory(2)
      // 用上面的代码，会出现动画卡顿
      this.positionLeft = '100%'
      let t1 = setTimeout(() => {
        this.isShowTwoCategory = false
        clearTimeout(t1)
      }, 500)
      let t2 = setTimeout(() => {
        this.categoryHeight = '0'
        this.menuShow = false
        let navIcon = item.navIcon ? item.navIcon : ''
        sessionStorage.setItem('banner', navIcon) // 供移动端用，列表页面刷新之后，vuex中就没数据了（因为页面刷新就不是从头部点击分类进去的，所以没有触发分类事件）
        this.$store.commit('SET_BANNER', navIcon)
        this.$router.push(`/product-list?oneId=${this.oneCategoryId}&twoId=${item.id}`)
        this.oneCategoryId = ''
        this.oneCategoryName = ''
        clearTimeout(t2)
      }, 450)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/css/mixin';
  .show-search {
    height: 48px;
  }
  #mobileHead {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9;
    .p-n02v3__shapelink:hover .p-n02v3__shapegradient {
      height: 35px;
    }
    .el-header {
      background-color: $blue;
      color: #fff;
      position: relative;
      z-index: 10;
      padding: 0;
      border-bottom: 1px solid #105476;
      box-sizing: border-box;
      overflow: inherit !important;
      .head-wrap {
        display: flex;
        justify-content: space-between;
        height: 100%;
        .iconfont {
          font-size: 20px;
        }
        .icon-cart4e {
          margin: 0 10px;
        }
        .user-cart {
          position: relative;
          .shopping-amount {
            position: absolute;
            top: -1px;
            right: 3px;
            padding: 1px;
            font-size: 12px;
            line-height: 14px;
            color: #fff;
            background-color: #f10215;
            -moz-border-radius: 50% 50% 50% 0;
            border-radius: 50% 50% 50% 0;
            min-width: 14px;
            text-align: center;
          }
        }
      }
    }
    .search-wrap {
      background: #176498;
      color: #fff;
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      z-index: 11;
      .query-search {
        -webkit-appearance: none;
        background-color: transparent;
        border: none;
        box-sizing: border-box;
        color: #fff;
        display: inline-block;
        font-size: inherit;
        outline: 0;
        padding: 10px;
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        width: 100%;
      }
      .icon-search1, .el-icon-close {
        height: 100%;
        width: 25px;
        text-align: center;
        line-height: 40px;
        font-size: 20px;
        color: #fff;
      }
      .auto-tip {
        position: absolute;
        top: 55px;
        left: 0;
        width: 100%;
        padding: 5px 0;
        max-height: 60vw;
        background: #fff;
        color: #606266;
        z-index: 9;
        overflow: auto;
        border-radius: 4px;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.7);
        .name {
          line-height: 2;
          padding: 0 20px;
        }
      }
    }
    .mobile-one-category {
      background: $blue;
      overflow: hidden;
      transition: all .5s ease;
      position: relative;
      z-index: 10;
      ul {
        padding: 5vw 2vw 0;
        li {
          // width: 25%;
          // text-align: center;
          color: #fff;
          margin-bottom: 5vw;
        }
      }
    }
    .mobile-category {
      position: fixed;
      left: 0;
      top: 48px;
      right: 0;
      bottom: 0;
      z-index: 10;
      .category-content {
        width: 100%;
        height: 100%;
        background: #176498;
        left: 100%;
        transition: all .5s ease;
        color: #fff;
        position: relative;
        overflow: auto;
        padding: 5vw 2vw;
        box-sizing: border-box;
        h3 {
          display: flex;
          align-items: center;
          .el-icon-arrow-left {
            font-size: 20px;
            padding-right: 10px;
            margin-top: 1px;
          }
        }
        ul {
          padding: 2vw 30px;
          li {
            line-height: 2.5;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  #mobileHead {
    .search-wrap {
      input::-webkit-input-placeholder {
        /* placeholder颜色  */
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MobileHead.vue